/* Storefront behaviours: product-card colour dots, collection sort + filter drawer. Safe to include several times. */
(() => {
  if (window.__storefrontInit) return;
  window.__storefrontInit = true;

  // Colour dots: hover/click swaps the card image and points links to that variant.
  const pick = (dot) => {
    const card = dot.closest('[data-pcard]');
    if (!card) return;
    card.querySelectorAll('.pcard__dot').forEach((d) => d.classList.toggle('is-active', d === dot));
    const img = card.querySelector('.pcard__img--1');
    if (img && dot.dataset.src) {
      img.removeAttribute('srcset');
      img.src = dot.dataset.src;
    }
    if (dot.dataset.url) card.querySelectorAll('a.pcard__media, a.pcard__title').forEach((a) => { a.href = dot.dataset.url; });
  };
  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.pcard__dot');
    if (dot) { e.preventDefault(); pick(dot); return; }

    const open = e.target.closest('[data-coll-filters-open]');
    if (open) {
      const dlg = document.getElementById(open.getAttribute('aria-controls'));
      if (dlg && !dlg.open) dlg.showModal();
      return;
    }
    const dlg = e.target.closest('[data-coll-filters]');
    if (e.target.closest('[data-coll-filters-close]') || (dlg && e.target === dlg)) dlg && dlg.close();
  });
  document.addEventListener('mouseover', (e) => {
    const dot = e.target.closest && e.target.closest('.pcard__dot');
    if (dot && window.matchMedia('(hover:hover)').matches) pick(dot);
  });

  // Sort: submit the toolbar form on change (keeps active filters as hidden inputs).
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-coll-sort]');
    if (sel) { sel.form.submit(); return; }
  });

  // Filter form: drop empty price inputs so the URL stays clean.
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-coll-filter-form]');
    if (!form) return;
    form.querySelectorAll('input[type=number]').forEach((i) => { if (i.value === '') i.disabled = true; });
  });
})();
